import React from 'react'

import '../../index.css';

import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

import SprayProgramList from '../SprayRecommendationPrograms/SprayProgramList';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ padding: '10px 0px 0px 0px' }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const SprayProgramComponent = () => {

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  return (
    <Box sx={{ bgcolor: 'background.paper', width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="inherit"
          variant="fullWidth"
          TabIndicatorProps={{ style: { background: "#7A9A01" } }}
        >
          <Tab label="Spray Programs" {...a11yProps(0)} />
          {/* <Tab label="Opened" {...a11yProps(1)} />
          <Tab label="Issued" {...a11yProps(2)} />
          <Tab label="Deleted" {...a11yProps(3)} /> */}
        </Tabs>
        </Box>

        <TabPanel value={value} index={0}>
            <SprayProgramList />
        </TabPanel>
        {/* <TabPanel value={value} index={1}>
          
        </TabPanel>
        <TabPanel value={value} index={2}>
          
        </TabPanel>
        <TabPanel value={value} index={3}>
          
        </TabPanel> */}
    </Box>
  )
}

export default SprayProgramComponent